import { type ReactNode } from 'react'
import cx from 'classnames'

import { timeago } from '@/utils/date-util'

import styles from './DetailsContent.module.css'

export interface DetailsContentProps {
  jobName: string
  jobShortId: string
  companyId?: string | null
  companyName?: string | null
  displayAccessMethod: string
  isConfirmAccess: boolean
  displayAction: string
  datePendingSince: Date
  helpText?: string
}

export function DetailsContent({
  jobName,
  jobShortId,
  companyId,
  companyName,
  displayAccessMethod,
  isConfirmAccess,
  displayAction,
  datePendingSince,
  helpText,
}: DetailsContentProps) {
  return (
    <div className={styles.root}>
      <h2 className={styles.title}>{jobName}</h2>
      <div className={styles.content}>
        <ContentItem label="Job ID">{jobShortId}</ContentItem>
        <ContentItem label="Company ID">{companyId ?? 'N/A'}</ContentItem>
        <ContentItem label="Company Name">{companyName ?? 'N/A'}</ContentItem>
        <ContentItem label="Method">{displayAccessMethod}</ContentItem>
        <ContentAction
          isConfirmAccess={isConfirmAccess}
          displayAction={displayAction}
        />
        <ContentItem label="Time in action">
          {timeago(datePendingSince, 'long')}
        </ContentItem>
        <ContentInstructions
          isConfirmAccess={isConfirmAccess}
          helpText={helpText}
        />
      </div>
    </div>
  )
}

interface ContentActionProps {
  isConfirmAccess: boolean
  displayAction: string
}

function ContentAction({ isConfirmAccess, displayAction }: ContentActionProps) {
  return (
    <>
      <div className={styles.label}>Action</div>
      <div
        className={cx(
          styles.value,
          isConfirmAccess && styles.actionConfirmAccess,
        )}
      >
        {displayAction}
      </div>
    </>
  )
}

interface ContentItemProps {
  label: string
  children?: ReactNode
}

function ContentItem({ label, children }: ContentItemProps) {
  return (
    <>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{children}</div>
    </>
  )
}

interface InstructionsProps {
  isConfirmAccess: boolean
  helpText?: string
}

function ContentInstructions({ isConfirmAccess, helpText }: InstructionsProps) {
  const content = isConfirmAccess ? (
    <>
      <p>{helpText}</p>
      <br />
      <p>This will allow the Pro to start the bookkeeping.</p>
    </>
  ) : (
    <>Unspecified</>
  )

  return <ContentItem label="Instructions">{content}</ContentItem>
}
